/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { AdmSubscriptionLite } from "../models/adm-subscription-lite";
import { AdmGroupLite } from "../models/adm-group-lite";
import { AdmCatalogTable } from "../models/adm-catalog-table";
import { AdmLayoutEx } from "../models/adm-layout-ex";
@Injectable({
  providedIn: "root",
})
class AdmLayoutService extends __BaseService {
  static readonly admLayoutGetAvailableSubscriptionsPath =
    "/api/AdmLayout/AvailableSubscriptions";
  static readonly admLayoutGetAvailableGroupsPath =
    "/api/AdmLayout/AvailableGroups/{subscriptionId}";
  static readonly admLayoutGetCatalogPath =
    "/api/AdmLayout/Catalog/{subscriptionId}/{groupId}";
  static readonly admLayoutGetAvailableFilterCategoriesPath =
    "/api/AdmLayout/AvailableFilterCategories/{subscriptionId}/{groupId}";
  static readonly admLayoutGetMyLayoutsPath = "/api/AdmLayout/MyLayouts";
  static readonly admLayoutGetLayoutPath = "/api/AdmLayout/Layout/{layoutId}";
  static readonly admLayoutCreateLayoutPath = "/api/AdmLayout/CreateLayout";
  static readonly admLayoutUpdateLayoutPath =
    "/api/AdmLayout/UpdateLayout/{layoutId}";
  static readonly admLayoutDeleteLayoutPath =
    "/api/AdmLayout/DeleteLayout/{layoutId}";
  static readonly admLayoutRegeneratePath =
    "/api/AdmLayout/Regenerate/{layoutId}";
  static readonly admLayoutGetLayoutStatusPath =
    "/api/AdmLayout/Status/{layoutId}";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  admLayoutGetAvailableSubscriptionsResponse(): __Observable<
    __StrictHttpResponse<Array<AdmSubscriptionLite>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/AdmLayout/AvailableSubscriptions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AdmSubscriptionLite>>;
      })
    );
  }
  admLayoutGetAvailableSubscriptions(): __Observable<
    Array<AdmSubscriptionLite>
  > {
    return this.admLayoutGetAvailableSubscriptionsResponse().pipe(
      __map((_r) => _r.body as Array<AdmSubscriptionLite>)
    );
  }

  /**
   * @param subscriptionId undefined
   */
  admLayoutGetAvailableGroupsResponse(
    subscriptionId: number
  ): __Observable<__StrictHttpResponse<Array<AdmGroupLite>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/AdmLayout/AvailableGroups/${subscriptionId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AdmGroupLite>>;
      })
    );
  }
  /**
   * @param subscriptionId undefined
   */
  admLayoutGetAvailableGroups(
    subscriptionId: number
  ): __Observable<Array<AdmGroupLite>> {
    return this.admLayoutGetAvailableGroupsResponse(subscriptionId).pipe(
      __map((_r) => _r.body as Array<AdmGroupLite>)
    );
  }

  /**
   * @param params The `AdmLayoutService.AdmLayoutGetCatalogParams` containing the following parameters:
   *
   * - `subscriptionId`:
   *
   * - `groupId`:
   */
  admLayoutGetCatalogResponse(
    params: AdmLayoutService.AdmLayoutGetCatalogParams
  ): __Observable<__StrictHttpResponse<Array<AdmCatalogTable>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/AdmLayout/Catalog/${params.subscriptionId}/${params.groupId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AdmCatalogTable>>;
      })
    );
  }
  /**
   * @param params The `AdmLayoutService.AdmLayoutGetCatalogParams` containing the following parameters:
   *
   * - `subscriptionId`:
   *
   * - `groupId`:
   */
  admLayoutGetCatalog(
    params: AdmLayoutService.AdmLayoutGetCatalogParams
  ): __Observable<Array<AdmCatalogTable>> {
    return this.admLayoutGetCatalogResponse(params).pipe(
      __map((_r) => _r.body as Array<AdmCatalogTable>)
    );
  }

  /**
   * @param params The `AdmLayoutService.AdmLayoutGetAvailableFilterCategoriesParams` containing the following parameters:
   *
   * - `subscriptionId`:
   *
   * - `groupId`:
   */
  admLayoutGetAvailableFilterCategoriesResponse(
    params: AdmLayoutService.AdmLayoutGetAvailableFilterCategoriesParams
  ): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/AdmLayout/AvailableFilterCategories/${params.subscriptionId}/${params.groupId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      })
    );
  }
  /**
   * @param params The `AdmLayoutService.AdmLayoutGetAvailableFilterCategoriesParams` containing the following parameters:
   *
   * - `subscriptionId`:
   *
   * - `groupId`:
   */
  admLayoutGetAvailableFilterCategories(
    params: AdmLayoutService.AdmLayoutGetAvailableFilterCategoriesParams
  ): __Observable<Array<string>> {
    return this.admLayoutGetAvailableFilterCategoriesResponse(params).pipe(
      __map((_r) => _r.body as Array<string>)
    );
  }
  admLayoutGetMyLayoutsResponse(): __Observable<
    __StrictHttpResponse<Array<AdmLayoutEx>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/AdmLayout/MyLayouts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AdmLayoutEx>>;
      })
    );
  }
  admLayoutGetMyLayouts(): __Observable<Array<AdmLayoutEx>> {
    return this.admLayoutGetMyLayoutsResponse().pipe(
      __map((_r) => _r.body as Array<AdmLayoutEx>)
    );
  }

  /**
   * @param layoutId undefined
   */
  admLayoutGetLayoutResponse(
    layoutId: number
  ): __Observable<__StrictHttpResponse<AdmLayoutEx>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/AdmLayout/Layout/${layoutId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmLayoutEx>;
      })
    );
  }
  /**
   * @param layoutId undefined
   */
  admLayoutGetLayout(layoutId: number): __Observable<AdmLayoutEx> {
    return this.admLayoutGetLayoutResponse(layoutId).pipe(
      __map((_r) => _r.body as AdmLayoutEx)
    );
  }

  /**
   * @param request undefined
   */
  admLayoutCreateLayoutResponse(
    request: AdmLayoutEx
  ): __Observable<__StrictHttpResponse<AdmLayoutEx>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdmLayout/CreateLayout`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmLayoutEx>;
      })
    );
  }
  /**
   * @param request undefined
   */
  admLayoutCreateLayout(request: AdmLayoutEx): __Observable<AdmLayoutEx> {
    return this.admLayoutCreateLayoutResponse(request).pipe(
      __map((_r) => _r.body as AdmLayoutEx)
    );
  }

  /**
   * @param params The `AdmLayoutService.AdmLayoutUpdateLayoutParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `layoutId`:
   */
  admLayoutUpdateLayoutResponse(
    params: AdmLayoutService.AdmLayoutUpdateLayoutParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdmLayout/UpdateLayout/${params.layoutId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `AdmLayoutService.AdmLayoutUpdateLayoutParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `layoutId`:
   */
  admLayoutUpdateLayout(
    params: AdmLayoutService.AdmLayoutUpdateLayoutParams
  ): __Observable<Blob> {
    return this.admLayoutUpdateLayoutResponse(params).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param layoutId undefined
   */
  admLayoutDeleteLayoutResponse(
    layoutId: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdmLayout/DeleteLayout/${layoutId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param layoutId undefined
   */
  admLayoutDeleteLayout(layoutId: number): __Observable<Blob> {
    return this.admLayoutDeleteLayoutResponse(layoutId).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param layoutId undefined
   */
  admLayoutRegenerateResponse(
    layoutId: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdmLayout/Regenerate/${layoutId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param layoutId undefined
   */
  admLayoutRegenerate(layoutId: number): __Observable<Blob> {
    return this.admLayoutRegenerateResponse(layoutId).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param layoutId undefined
   */
  admLayoutGetLayoutStatusResponse(
    layoutId: number
  ): __Observable<__StrictHttpResponse<AdmLayoutEx>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/AdmLayout/Status/${layoutId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmLayoutEx>;
      })
    );
  }
  /**
   * @param layoutId undefined
   */
  admLayoutGetLayoutStatus(layoutId: number): __Observable<AdmLayoutEx> {
    return this.admLayoutGetLayoutStatusResponse(layoutId).pipe(
      __map((_r) => _r.body as AdmLayoutEx)
    );
  }
}

module AdmLayoutService {
  /**
   * Parameters for AdmLayoutGetCatalog
   */
  export interface AdmLayoutGetCatalogParams {
    subscriptionId: number;
    groupId: number;
  }

  /**
   * Parameters for AdmLayoutGetAvailableFilterCategories
   */
  export interface AdmLayoutGetAvailableFilterCategoriesParams {
    subscriptionId: number;
    groupId: number;
  }

  /**
   * Parameters for AdmLayoutUpdateLayout
   */
  export interface AdmLayoutUpdateLayoutParams {
    request: AdmLayoutEx;
    layoutId: number;
  }
}

export { AdmLayoutService };
